import State from './state'
import Mutations from './mutations'
import Actions from './actions'
import Getters from './getters'
export default {
  state: State,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
}
